import { render, staticRenderFns } from "./production-order-detail.vue?vue&type=template&id=2b5f5609&scoped=true"
import script from "./production-order-detail.vue?vue&type=script&lang=js"
export * from "./production-order-detail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b5f5609",
  null
  
)

export default component.exports